import React from 'react';
import { motion } from 'framer-motion';
export function AboutLorena() {
  return <section className="py-24 px-6 bg-pearl-white" data-id="element-15">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-16">
        {/* Left Column - Image */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative flex flex-col items-center md:items-start" data-id="element-17">
          <div className="relative w-full max-w-[480px]" data-id="element-18">
            <div className="absolute -top-4 -right-4 bg-champagne-gold text-white font-montserrat font-semibold text-sm py-2 px-6 rounded-full z-10 shadow-lg" data-id="element-19">
              54 años | 25 años con Herbalife
            </div>
            <img src="https://cdn.magicpatterns.com/uploads/7BAetqRRA9ZnQQZsz7Rov4/ChatGPT_Image_18_may_2026,_19_50_06.png" alt="Lorena Pérez" className="w-full h-auto rounded-3xl border-4 border-champagne-gold/30 shadow-luxury-card object-cover" data-id="element-20" />
          </div>

          <div className="flex flex-col sm:flex-row gap-3 mt-6 w-full max-w-[480px]" data-id="element-21">
            <div className="bg-deep-blue text-white font-montserrat text-sm py-2 px-4 rounded-full flex-1 text-center shadow-md pt-[16px] pb-[16px]" data-id="element-22">
              🌿 Saludable sin ser Esclavo
            </div>
            <div className="bg-champagne-gold text-white font-montserrat text-sm py-2 px-4 rounded-full flex-1 text-center shadow-md" data-id="element-23">
              💚 Fundadora RenuevaTE_90
            </div>
          </div>
        </motion.div>

        {/* Right Column - Text */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="flex flex-col" data-id="element-24">
          <span className="text-champagne-gold font-montserrat font-semibold text-xs tracking-[0.2em] uppercase mb-4" data-id="element-25">
            Conoce a Lorena Pérez
          </span>

          <h2 className="font-playfair font-bold text-deep-blue text-3xl md:text-[42px] leading-[1.2] mb-6" data-id="element-26">
            No Hablo de Salud
            <br data-id="element-27" />
            desde la Teoría.
            <br data-id="element-28" />
            Yo la Vivo.
          </h2>

          <div className="w-[80px] h-[2px] bg-champagne-gold mb-8" data-id="element-29"></div>

          <p className="font-montserrat text-soft-black text-base leading-[1.9] mb-8" data-id="element-30">
            Con más de 25 años usando los productos Herbalife como parte de mi
            estilo de vida, a mis 54 años mi energía, mi fuerza y mi vitalidad
            son mi mejor carta de presentación.
          </p>

          <div className="bg-[#EEF2FF] border-l-4 border-champagne-gold rounded-r-lg p-6 mb-8" data-id="element-31">
            <p className="font-cormorant italic text-deep-blue text-2xl leading-relaxed" data-id="element-32">
              "Mi misión es acompañar a mujeres hispanas de 40 años o más a
              despertar su cuerpo, recuperar su confianza y vivir saludable sin
              esclavitud — con estructura, propósito y acompañamiento real."
            </p>
          </div>

          <p className="font-montserrat text-gray-text text-base mb-8" data-id="element-33">
            Porque después de los 40, el cuerpo no se apaga. Se renueva. Y yo
            soy la prueba viviente de eso.
          </p>

          <div className="border-t border-dashed border-champagne-gold mb-8" data-id="element-34"></div>

          <div className="mb-10" data-id="element-35">
            <h3 className="font-montserrat font-semibold text-deep-blue text-sm tracking-widest uppercase mb-4" data-id="element-36">
              Fundadora de:
            </h3>
            <div className="space-y-4" data-id="element-37">
              <div className="flex items-start gap-3" data-id="element-38">
                <span className="text-xl" data-id="element-39">🌿</span>
                <div data-id="element-40">
                  <p className="font-montserrat font-bold text-deep-blue" data-id="element-41">
                    Saludable sin ser Esclavo
                  </p>
                  <p className="font-montserrat text-gray-text text-sm" data-id="element-42">
                    Movimiento de vida saludable sin restricciones ni esclavitud
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-43">
                <span className="text-xl" data-id="element-44">💚</span>
                <div data-id="element-45">
                  <p className="font-montserrat font-bold text-deep-blue" data-id="element-46">
                    RenuevaTE_90
                  </p>
                  <p className="font-montserrat text-gray-text text-sm" data-id="element-47">
                    Programa de nutrición, fuerza y acompañamiento para mujeres
                    40+
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-deep-blue rounded-2xl p-8 relative mb-10" data-id="element-48">
            <span className="absolute top-4 left-4 font-cormorant text-champagne-gold/30 text-6xl leading-none" data-id="element-49">
              "
            </span>
            <p className="font-cormorant italic text-white text-[26px] text-center relative z-10 mb-4" data-id="element-50">
              Después de los 40, el cuerpo no se apaga. Se renueva.
            </p>
            <p className="font-montserrat text-champagne-gold text-sm text-center" data-id="element-51">
              — Lorena Pérez | RenuevaTE_90
            </p>
          </div>

          <p className="font-cormorant italic text-soft-black text-xl leading-relaxed mb-8" data-id="element-52">
            Yo no llegué al bienestar porque todo fue fácil. Llegué porque
            decidí no rendirme cuando fue difícil. Y esa decisión, tomada cada
            día durante más de 25 años, es lo que hoy tengo el privilegio de
            enseñarle a otras mujeres.
          </p>

          <p className="font-montserrat text-gray-text text-sm mb-6 italic" data-id="element-53">
            La experiencia sumada a la preparación profesional hacen que pueda
            guiarte con conocimiento pero con entendimiento de tu realidad.
          </p>

          <ul className="space-y-3 font-montserrat text-sm text-soft-black" data-id="element-54">
            <li className="flex gap-3" data-id="element-55">
              <span className="shrink-0" data-id="element-56">🎓</span> Licenciada en Educación
              Integral — UNELLEZ, Barinas, Venezuela
            </li>
            <li className="flex gap-3" data-id="element-57">
              <span className="shrink-0" data-id="element-58">🏋🏽‍♀️</span> Entrenadora Personal
              Certificada
            </li>
            <li className="flex gap-3" data-id="element-59">
              <span className="shrink-0" data-id="element-60">🌿</span> Certificada en Fundamentos de
              Nutrición
            </li>
            <li className="flex gap-3" data-id="element-61">
              <span className="shrink-0" data-id="element-62">🌿</span> Certificada como Coach de
              Estilo de Vida para el Programa Nacional de Prevención de la
              Diabetes por CDC
            </li>
            <li className="flex gap-3" data-id="element-63">
              <span className="shrink-0" data-id="element-64">💚</span> Distribuidora Independiente
              Herbalife con más de 25 años de experiencia personal y profesional
            </li>
          </ul>
        </motion.div>
      </div>
    </section>;
}